import ChatIcon from "@mui/icons-material/Chat";
import { IconButton } from "@mui/material";
import { useHash } from "react-use";
import { useSigninCheck } from "reactfire";
import { useGlobalState } from "~/lib/chat";

function ToggleChatPanelButtonLoggedIn() {
  const [, setHash] = useHash();
  const [chatOpen] = useGlobalState("chatOpen");

  console.log("ToggleChatPanelButton render", { chatOpen });

  const handleClick = () => {
    if (chatOpen) {
      setHash("");
      console.log("ToggleChatPanelButton closing...", { chatOpen });
    } else {
      setHash("chat");
      console.log("ToggleChatPanelButton opening...", { chatOpen });
    }
  };

  return (
    <IconButton
      aria-label="toggle chat"
      edge={false}
      onClick={handleClick}
      color="primary"
      size="large"
      sx={{ p: 1.5 }}
    >
      <ChatIcon sx={{ fontSize: 34 }} />
    </IconButton>
  );
}

export default function ToggleChatPanelButton(): React.ReactElement {
  const { data: signInCheckResult } = useSigninCheck();
  if (signInCheckResult?.signedIn) {
    return <ToggleChatPanelButtonLoggedIn />;
  } else {
    return <div />;
  }
}
